module.exports = __webpack_public_path__ + "assets/2d5439e86233120f7294144b0d2218ae.png";